/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation
} from '@tanstack/react-query'
import type {
  MutationFunction,
  UseMutationOptions
} from '@tanstack/react-query'
import type {
  TestingComparisonCreateDataRequest
} from '../../model/testingComparisonCreateDataRequest'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Creates a queue entry to compare customers
 */
export const internalIntegrationTestingComparisonCreate = (
    testingComparisonCreateDataRequest: TestingComparisonCreateDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/integration-testing-comparison/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: testingComparisonCreateDataRequest
    },
      options);
    }
  


export const getInternalIntegrationTestingComparisonCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalIntegrationTestingComparisonCreate>>, TError,{data: TestingComparisonCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof internalIntegrationTestingComparisonCreate>>, TError,{data: TestingComparisonCreateDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof internalIntegrationTestingComparisonCreate>>, {data: TestingComparisonCreateDataRequest}> = (props) => {
          const {data} = props ?? {};

          return  internalIntegrationTestingComparisonCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InternalIntegrationTestingComparisonCreateMutationResult = NonNullable<Awaited<ReturnType<typeof internalIntegrationTestingComparisonCreate>>>
    export type InternalIntegrationTestingComparisonCreateMutationBody = TestingComparisonCreateDataRequest
    export type InternalIntegrationTestingComparisonCreateMutationError = unknown

    export const useInternalIntegrationTestingComparisonCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalIntegrationTestingComparisonCreate>>, TError,{data: TestingComparisonCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInternalIntegrationTestingComparisonCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    